export { CollectionPage } from "./CollectionPage";
